import React from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Printer, Download, Check, Eye } from 'lucide-react';
export function Letters() {
  return <div className="flex h-[calc(100vh-8rem)] gap-6" data-id="element-214">
      {/* Left Panel: Batches */}
      <div className="w-1/3 flex flex-col gap-6" data-id="element-215">
        <div data-id="element-216">
          <h1 className="text-2xl font-bold text-stone-900" data-id="element-217">Letters</h1>
          <p className="text-stone-500 mt-1" data-id="element-218">
            Review and print generated batches.
          </p>
        </div>

        <div className="flex-1 overflow-y-auto space-y-4 pr-2" data-id="element-219">
          {[1, 2, 3].map(i => <Card key={i} className={`cursor-pointer transition-all ${i === 1 ? 'ring-2 ring-teal-500 border-transparent' : 'hover:border-stone-300'}`} data-id="element-220">
              <div className="flex justify-between items-start mb-2" data-id="element-221">
                <h3 className="font-semibold text-stone-900" data-id="element-222">
                  Batch #{202400 + i}
                </h3>
                <Badge variant={i === 1 ? 'warning' : 'success'} data-id="element-223">
                  {i === 1 ? 'Pending Review' : 'Printed'}
                </Badge>
              </div>
              <div className="text-sm text-stone-600 mb-3" data-id="element-224">
                Fall 2024 Literacy Update
              </div>
              <div className="flex items-center justify-between text-xs text-stone-500" data-id="element-225">
                <span data-id="element-226">1,250 Letters</span>
                <span data-id="element-227">Generated Oct 30</span>
              </div>
            </Card>)}
        </div>
      </div>

      {/* Right Panel: Preview */}
      <div className="flex-1 bg-stone-200 rounded-xl p-8 overflow-y-auto flex justify-center" data-id="element-228">
        <div className="bg-white w-full max-w-[210mm] min-h-[297mm] shadow-lg p-12 text-stone-800 flex flex-col" data-id="element-229">
          {/* Letter Header */}
          <div className="flex justify-between items-start mb-12 border-b border-stone-100 pb-8" data-id="element-230">
            <div className="flex items-center gap-3" data-id="element-231">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center text-white font-bold text-2xl" data-id="element-232">
                L
              </div>
              <div data-id="element-233">
                <div className="font-bold text-xl text-stone-900" data-id="element-234">
                  Lincoln Elementary
                </div>
                <div className="text-sm text-stone-500" data-id="element-235">
                  District 4 Public Schools
                </div>
              </div>
            </div>
            <div className="text-right text-sm text-stone-500" data-id="element-236">
              <div data-id="element-237">October 30, 2024</div>
              <div data-id="element-238">Re: Maya Johnson</div>
            </div>
          </div>

          {/* Letter Body */}
          <div className="space-y-6 flex-1" data-id="element-239">
            <h2 className="text-2xl font-bold text-stone-900" data-id="element-240">
              Literacy Progress Update
            </h2>

            <p className="leading-relaxed" data-id="element-241">Dear Family of Maya Johnson,</p>

            <p className="leading-relaxed" data-id="element-242">
              At Lincoln Elementary, we are committed to ensuring every student
              becomes a confident reader. We recently completed our fall reading
              assessment, and we want to share Maya's progress with you.
            </p>

            {/* Score Highlight Box */}
            <div className="bg-teal-50 border border-teal-100 rounded-xl p-8 my-8 text-center" data-id="element-243">
              <div className="text-sm text-teal-800 font-medium uppercase tracking-wide mb-2" data-id="element-244">
                Current Reading Level
              </div>
              <div className="text-4xl font-bold text-teal-700 mb-2" data-id="element-245">
                On Track
              </div>
              <p className="text-teal-800 max-w-md mx-auto" data-id="element-246">
                Maya is reading at grade level! Her score of{' '}
                <strong data-id="element-247">650L</strong> indicates she is ready for 3rd grade
                reading materials.
              </p>
            </div>

            <h3 className="font-bold text-lg text-stone-900" data-id="element-248">
              What this means
            </h3>
            <p className="leading-relaxed" data-id="element-249">
              Maya demonstrates a strong understanding of vocabulary and can
              comprehend complex sentences. She is well-prepared for the reading
              challenges of this school year.
            </p>

            <h3 className="font-bold text-lg text-stone-900" data-id="element-250">
              How you can help at home
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-251">
              <li data-id="element-252">Encourage Maya to read for 20 minutes each day.</li>
              <li data-id="element-253">
                Ask questions about the stories she reads to build
                comprehension.
              </li>
              <li data-id="element-254">Visit the local library to find books that interest her.</li>
            </ul>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-stone-100 text-center text-sm text-stone-500" data-id="element-255">
            <p data-id="element-256">
              Questions? Contact Mrs. Anderson at (555) 123-4567 or email
              s.anderson@lincoln.edu
            </p>
          </div>
        </div>
      </div>

      {/* Floating Action Bar */}
      <div className="fixed bottom-8 right-8 flex gap-3" data-id="element-257">
        <Button variant="secondary" icon={<Eye size={16} data-id="element-259" />} data-id="element-258">
          Preview Next
        </Button>
        <Button icon={<Printer size={16} data-id="element-261" />} data-id="element-260">Print Batch (1,250)</Button>
      </div>
    </div>;
}